import { render } from "./mainPageTitle.vue?vue&type=template&id=5526a65c&scoped=true"
const script = {}

import "./mainPageTitle.vue?vue&type=style&index=0&id=5526a65c&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5526a65c"]])

export default __exports__